import { Injectable } from '@angular/core';
import { ReplaySubject, Observable, Subject } from 'rxjs';
import { HeaderAction } from '../../models/header-action';
import { IHeaderActionsService } from './header-actions.service.interface';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HeaderActionsService implements IHeaderActionsService {

  private _headerActionClicked: Subject<string> = new Subject<string>();
  public actions: Array<{ identifier: string, action: HeaderAction }> = [];
  public actionsStream: ReplaySubject<Array<HeaderAction>> = new ReplaySubject(1);

  constructor() { }

  public addHeaderAction(identifier: string, action: HeaderAction) {
    if (this.actions.findIndex(a => a.identifier == identifier) == -1) {
      this.actions.push({ identifier, action });
      this.actionsStream.next(this.getHeaderActionArray());
    }
  }

  public removeHeaderAction(identifier: string) {
    let actionIndex: number = this.actions.findIndex(a => a.identifier == identifier);
    if (actionIndex > -1) {
      this.actions.splice(actionIndex, 1);
      this.actionsStream.next(this.getHeaderActionArray());
    }
  }

  public getHeaderActionsStream(): Observable<Array<HeaderAction>> {
    return this.actionsStream;
  }

  public notifyActionHeaderClicked(key: string): void {
    this._headerActionClicked.next(key);
  }

  public onHeaderActionClicked(key: string): Observable<boolean> {
    return this._headerActionClicked.pipe(
      filter((actionKey) => {
        return key.toLowerCase() === actionKey.toLowerCase()
      }),
      map(() => { return true; })
    );
  }

  private getHeaderActionArray(): Array<HeaderAction> {
    return this.actions.map(action => action.action);
  }

}
